import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
} from "@mui/material"
import { CrudProvider } from "@/context/crudContext"
import { CustomTable } from "@/components/Tables/CustomTable"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { columns } from "@/pages/purchase/ProductsColumns"
import Grid from "@mui/material/Grid2"
import RecentOrders from "@/components/Orders/RecentOrders"
import OrderSummary from "@/components/Orders/OrderSummary"
import CustomerDetails from "@/components/Products/CustomerDetails"
import { DetailTable } from "@/components/Tables/DetailTable"
const PurchaseDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["purchase-detail", id], `purchase/${id}`)

  const [totalItems, setTotalItems] = useState(0)
  const [totalQuantity, setTotalQuantity] = useState(0)
  const purchase = response?.data

  useEffect(() => {
    if (purchase?.products?.length) {
      setTotalItems(purchase.products.length)
      setTotalQuantity(
        purchase.products.reduce((sum, item) => sum + item.quantity, 0)
      )
    }
  }, [purchase?.products])

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5 className="text-lg font-semibold">Purchase Details</h5>

        <ul className="breadcrumb text-sm">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/purchase">Purchase</Link>
          </li>
          <li>{purchase.reference_number}</li>
        </ul>
      </div>

      {/* Responsive Grid Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-4 xxl:grid-cols-5 gap-6">
        {/* Left Section (Product Table) */}
        <div className="card bg-white border-0 px-4 py-4 rounded-3 mb-4 lg:col-span-3">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mt-2 mb-4">
            <p className="text-base font-semibold text-black">Products</p>
          </div>

          <CrudProvider>
            <ProductList purchase={purchase} isLoading={isLoading} />
          </CrudProvider>
        </div>

        {/* Right Section (Details Summary) */}
        <div className="card bg-white border-0 p-4 rounded-3 mb-4">
          <div className="space-y-4">
            <DetailItem
              label="Reference Number"
              value={purchase.reference_number}
            />
            <DetailItem label="Supplier" value={purchase.supplier.name} />
            <DetailItem label="Total Items" value={totalItems} />
            <DetailItem label="Total Quantity" value={totalQuantity} />
            <DetailItem label="Date" value={purchase.date} />
            <DetailItem label="Created By" value={purchase.createdBy.name} />
            <DetailItem label="Updated By" value={purchase.updatedBy.name} />
          </div>
        </div>
      </div>
    </>
  )
}

function ProductList({ purchase, isLoading }) {
  return (
    <DetailTable
      label="Orders"
      columns={columns}
      data={purchase.products}
      isLoading={isLoading}
    />
  )
}

function DetailItem({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-600">{label}:</p>
      <span className="block font-medium text-black mt-1 text-sm break-all">
        {value}
      </span>
    </div>
  )
}

export default PurchaseDetails
